import React, { useEffect, useState } from "react";

interface CanvasSandboxProps {
  code: string;
}

const CANVAS_WIDTH = 960;
const CANVAS_HEIGHT = 540;

const buildSrcDoc = (userCode: string): string => {
  const safeCode = userCode.replace(/<\/script/gi, "<\\/script");
  return `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<style>
  html, body { margin: 0; background: #0b0f1a; overflow: hidden; }
  canvas { display: block; width: 100%; height: 100%; }
  #error {
    position: absolute; inset: 0; display: none;
    color: #ff9a9a; font: 12px/1.5 monospace; padding: 10px;
    white-space: pre-wrap; background: rgba(0,0,0,0.88);
  }
</style>
</head>
<body>
<canvas id="c" width="${CANVAS_WIDTH}" height="${CANVAS_HEIGHT}"></canvas>
<div id="error"></div>
<script>
(function () {
  var canvas = document.getElementById("c");
  var ctx = canvas.getContext("2d");
  var errorEl = document.getElementById("error");
  var start = performance.now();
  var stopped = false;

  function showError(message) {
    stopped = true;
    errorEl.style.display = "block";
    errorEl.textContent = "Canvas script error: " + message;
  }

  window.onerror = function (message) {
    showError(message);
    return true;
  };

  try {
    ${safeCode}
  } catch (e) {
    showError(e && e.message ? e.message : String(e));
  }

  function loop() {
    if (stopped) return;
    var t = (performance.now() - start) / 1000;
    try {
      if (typeof draw === "function") {
        draw(ctx, t, canvas.width, canvas.height);
      }
    } catch (e) {
      showError(e && e.message ? e.message : String(e));
      return;
    }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();
</script>
</body>
</html>`;
};

const CanvasSandbox: React.FC<CanvasSandboxProps> = ({ code }) => {
  const [stableCode, setStableCode] = useState(code);

  useEffect(() => {
    const timeout = setTimeout(() => setStableCode(code), 400);
    return () => clearTimeout(timeout);
  }, [code]);

  return (
    <div className="lesson-canvas2d">
      <iframe
        key={stableCode}
        title="Canvas animation"
        srcDoc={buildSrcDoc(stableCode)}
        sandbox="allow-scripts"
        referrerPolicy="no-referrer"
        loading="lazy"
      />
    </div>
  );
};

export default CanvasSandbox;
